import { Injectable } from '@angular/core';

import { WeappsServices } from 'data/api/weapps';
import type { paths as ALDEBARAN_PATHS } from '../api/weapps/aldebaran'

export type ProgressReport = ALDEBARAN_PATHS["/progress/report"]["get"]["responses"][200]["content"]['application/json'];

@Injectable({
  providedIn: 'root'
})
export class NewProgressService {

  public async reportModuleProgress(
    productId: string, 
    moduleId: string, 
    contentId: string, 
    groupId?:string
  ):Promise<boolean> {
    const api = await WeappsServices.aldebaran();
    const response = await api.POST('/progress/report', {
      body: {
          productId: productId,
          moduleId: moduleId,
          contentId: contentId,
          groupId: groupId?groupId:undefined,
      }
    });
    if (response.response.status !== 200 || !response.data) {
      throw new Error(`Failed to fetch data: ${response.response.statusText}`);
    } else {
      return true;
    }
  }

  public async loadProgress(productId:string): Promise<ProgressReport|null> {
    const api = await WeappsServices.aldebaran();
    const response = await api.GET('/progress/report', {
      params: {
        query:{
          productId: productId,
        }
      }
    });
    if (response.response.status == 200) {
      return response.data;
    }else if (response.response.status === 404) {
      return null;
    }else{
      throw new Error(`Failed to fetch data: ${response.response.statusText}`);
    }
  }  
}

